<template>
  <div>
    <q-toolbar class="q-pr-none q-mb-md justify-end">
      <!-- <q-input outlined v-model="search" dense type="text" label="Pesquisar">
              <template v-slot:prepend>
                <q-icon name="eva-search-outline" />
              </template>
            </q-input> -->
      <q-btn
        outline
        icon="mdi-filter-outline"
        color="primary"
        no-caps
        class="q-px-sm q-mx-sm"
        :label="$t('filter')"
        @click="filter = !filter"
      >
        <q-tooltip> {{ $t('filter_report') }}</q-tooltip>
      </q-btn>
    </q-toolbar>
    <!-- <q-intersection transition="slide-down" v-show="filter"> -->
    <q-card flat v-if="filter" bordered class="q-mb-sm">
      <q-toolbar>
        <!-- <q-toolbar-title> {{ $t("filter") }}</q-toolbar-title> -->
        <q-btn flat round dense class="q-ml-auto" icon="mdi-close" @click="filter = false" />
      </q-toolbar>
      <q-card-section class="q-pt-none row q-col-gutter-md">
        <div class="col-4">
          <select-request
            :v-model="params.advertiserId"
            outlined
            endpoint="redirect?app=ADVERTISER&path=/api/get/advertiser"
            option-label="trademark"
            option-value="id"
            :label="$t('fantasy_name')"
            clearable
            @update="(value) => (params.advertiserId = value === null ? 0 : value.id)"
            :formatLabelAdvertiser="true"
          />
        </div>
        <div class="col-5">
          <q-select
            :label="$t('campaign')"
            outlined
            use-input
            clearable
            input-debounce="300"
            @filter="filterCampaigns"
            v-model="params.campaignId"
            :options="campaignsFiltered"
            option-label="name"
            option-value="id"
            emit-value
            map-options
            multiple
          >
            <template v-slot:selected>
              <div class="ellipsis" style="max-width: 100%">
                {{ selectedCampaignsText }}
              </div>
            </template>
            <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
              <q-item dense clickable v-ripple v-bind="itemProps" @click="handleCampaignClick(opt, toggleOption)">
                <q-item-section side>
                  <q-checkbox
                    dense
                    :value="opt.id === 'select-all' ? allCampaignsSelected : selected"
                    @input="handleCampaignClick(opt, toggleOption)"
                  />
                </q-item-section>
                <q-item-section>
                  <q-item-label :class="{ 'text-weight-bold': opt.id === 'select-all' }">
                    {{ opt.name }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
        <div class="col-3">
          <select-request
            :label="$t('segmentation')"
            :v-model="params.segmentation"
            outlined
            endpoint="redirect?app=ADVERTISER&path=/api/get/campaign/segmentation"
            option-label="description"
            option-value="id"
            clearable
            @update="(value) => (params.segmentation = value === null ? null : value.id)"
          />
        </div>
        <div class="col-4">
          <date-input
            buttons
            ref="dateInput"
            outlined
            :label="$t('conversion_date')"
            :v-model="params.date"
            @update="(value) => (params.date = value)"
            clearable
            today-btn
            range
          />
        </div>

        <div class="col-3">
          <select-request
            :v-model="params.siteId"
            outlined
            endpoint="/redirect?app=AFFILIATE&path=/api/v2/affiliate/site/list"
            option-label="name"
            option-value="id"
            :label="$t('channel_name')"
            clearable
            @update="(value) => (params.siteId = value === null ? null : value.id)"
            :formatLabelChannel="true"
          />
        </div>
        <div class="col-3">
          <div class="row q-col-gutter-sm">
            <div class="col">
              <q-select
                v-model="params.status"
                :options="[
                  {
                    label: $t('approved'),
                    value: 2
                  },
                  {
                    label: $t('pending'),
                    value: 1
                  },
                  {
                    label: $t('refused'),
                    value: 0
                  }
                ]"
                :label="$t('conversion_status')"
                outlined
                clearable
                clear-icon="mdi-close"
              />
            </div>
          </div>
        </div>

        <div class="col-2 row justify-center items-center">
          <q-btn
            outline
            dense
            no-caps
            flat
            color="primary"
            icon="search"
            :label="$t('advanced_search')"
            @click="advanced_search = !advanced_search"
          />
        </div>

        <q-slide-transition @hide="clearAdvancedSearch()">
          <div v-if="advanced_search">
            <div class="row q-col-gutter-md">
              <div class="col-4">
                <select-request
                  :v-model="params.affiliateId"
                  outlined
                  endpoint="/redirect?app=affiliate&path=/api/get/affiliate/search"
                  option-label="name"
                  option-value="id"
                  :label="$t('affiliate_id')"
                  clearable
                  @update="(value) => (params.affiliateId = value === null ? 0 : value.id)"
                  :formatLabelAffiliate="true"
                />
              </div>
              <div class="col-3">
                <select-request
                  :v-model="params.manager_id"
                  :endpoint="'/user/managers-unblocked'"
                  :label="$t('manager')"
                  outlined
                  clearable
                  option-label="name"
                  option-value="user_id"
                  @update="(val) => (params.manager_id = val === null ? 0 : val.user_id)"
                />
              </div>
              <div class="col-2">
                <q-select
                  outlined
                  v-model="params.commissionType"
                  type="text"
                  :options="[
                    { label: 'CPA', value: 'cpa' },
                    { label: 'CPL', value: 'cpl' },
                    { label: 'Bônus', value: 'bonus' }
                  ]"
                  option-label="label"
                  option-value="value"
                  :label="$t('type')"
                />
              </div>

              <div class="col-3">
                <select-request
                  :v-model="params.network_manager_id"
                  outlined
                  endpoint="/user/affiliate/managers/redes"
                  option-label="name"
                  option-value="user_id"
                  :label="$t('affiliate_manager')"
                  clearable
                  @update="(value) => (params.network_manager_id = value === null ? 0 : value.user_id)"
                />
              </div>

              <div class="col-2.5">
                <q-input outlined v-model="params.orderId" type="text" :label="$t('request_number')" />
              </div>
              <div class="col-1.5">
                <q-input outlined v-model="params.actionId" type="text" :label="$t('conversion_id')" />
              </div>
              <div class="col-1.5">
                <q-input outlined v-model="params.bonusId" type="text" :label="$t('bonus_id')" />
              </div>

              <div class="col-3">
                <date-input
                  buttons
                  outlined
                  :label="$t('validation_date')"
                  :v-model="params.validation_date"
                  @update="(value) => (params.validation_date = value)"
                  clearable
                  today-btn
                  range
                />
              </div>

              <div class="col-3">
                <date-input
                  buttons
                  outlined
                  :label="$t('payment_date')"
                  :v-model="params.payment_date"
                  @update="(value) => (params.payment_date = value)"
                  clearable
                  today-btn
                  range
                />
              </div>
            </div>
          </div>
        </q-slide-transition>

        <div class="col-6">
          <q-checkbox
            v-model="params.test_campaigns"
            :false-value="true"
            :true-value="false"
            :label="$t('dont_show_test_campaign')"
          />
        </div>

        <div class="col-6 text-right">
          <q-btn color="primary" :label="$t('clear')" no-caps outline class="q-px-md q-mx-md" @click="clearFilter" />
          <q-btn color="positive" :label="$t('search')" no-caps unelevated class="q-px-md" @click="onFilterReports" />
        </div>
      </q-card-section>
    </q-card>
    <!-- </q-intersection> -->

    <q-card v-if="showExcludedCampaigns" flat bordered class="q-mb-sm bg-blue-1">
      <q-card-section class="q-py-sm">
        <div class="row items-center">
          <q-icon name="mdi-information-outline" color="primary" size="sm" class="q-mr-sm" />
          <span class="text-body2">
            <strong>{{ $t('showing_all_campaigns_except') }}:</strong>
            {{ excludedCampaignsText }}
          </span>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import ReportMixin from '../../mixins/ReportMixin';
import SelectRequest from '@/widgets/inputsGlobal/SelectRequest.vue';
import DateInput from '../../widgets/inputsGlobal/DateInput.vue';

export default {
  name: 'HeaderConversionReports',
  components: { SelectRequest, DateInput },
  mixins: [ReportMixin],
  data() {
    return {
      filter: true,
      campaignsList: [],
      campaignsFiltered: [],
      searchExecuted: false,
      lastSearchCampaignIds: [],

      params: {
        orderId: null,
        actionId: null,
        bonusId: null,
        advertiserId: null,
        campaignId: [],
        date: '',
        validation_date: '',
        status: null,
        affiliateId: null,
        siteName: null,
        commissionType: null,
        manager_id: null,
        test_campaigns: false,
        segmentation: null,
        network_manager_id: null,
        payment_date: null
      },
      advanced_search: false
    };
  },

  computed: {
    selectedCampaignsText() {
      if (!this.params.campaignId || !this.params.campaignId.length) return '';

      const selectedNames = this.params.campaignId
        .map((id) => this.campaignsList.find((c) => c.id === id)?.name)
        .filter(Boolean);

      if (selectedNames.length <= 1) {
        return selectedNames.join(', ');
      }

      return `${selectedNames.slice(0, 1).join(', ')}... +${selectedNames.length - 1}`;
    },
    allCampaignsSelected() {
      const realCampaigns = this.campaignsFiltered.filter((c) => c.id !== 'select-all');
      return realCampaigns.length > 0 && this.params.campaignId?.length === realCampaigns.length;
    },

    showExcludedCampaigns() {
      if (!this.searchExecuted) return false;

      if (!this.lastSearchCampaignIds || this.lastSearchCampaignIds.length === 0) return false;

      const realCampaigns = this.campaignsList.filter((c) => c.id !== 'select-all');
      const selectedCount = this.lastSearchCampaignIds.length;

      return selectedCount > 30 && selectedCount < realCampaigns.length;
    },

    excludedCampaignsText() {
      const realCampaigns = this.campaignsList.filter((c) => c.id !== 'select-all');
      const notSelectedCampaigns = realCampaigns
        .filter((c) => !this.lastSearchCampaignIds.includes(c.id))
        .map((c) => c.name);

      return notSelectedCampaigns.join(', ');
    }
  },

  mounted() {
    const yesterday = {
      to: this.$moment(),
      from: this.$moment().subtract(1, 'days')
    };
    this.$refs.dateInput.setValue(yesterday);

    this.getCampaigns();
  },

  methods: {
    clearAdvancedSearch() {
      this.params.affiliateId = null;
      this.params.manager_id = null;
      this.params.commissionType = null;
      this.params.network_manager_id = null;
      this.params.orderId = null;
      this.params.actionId = null;
      this.params.bonusId = null;
      this.params.validation_date = null;
      this.params.payment_date = null;
    },

    handleCampaignClick(opt, toggleOption) {
      if (opt.id === 'select-all') {
        if (this.allCampaignsSelected) {
          this.params.campaignId = [];
        } else {
          // Seleciona todas exceto o próprio "Selecionar todas"
          this.params.campaignId = this.campaignsFiltered.filter((c) => c.id !== 'select-all').map((c) => c.id);
        }
      } else {
        toggleOption(opt);
      }
    },

    async getCampaigns() {
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get('/redirect?app=ADVERTISER&path=/api/get/campaign');
        if (status == 200) {
          this.campaignsList = [
            { id: 'select-all', name: this.$t('select_all') },
            ...data.map((item) => ({
              ...item,
              name: `${item.name} (ID:${item.id})`
            }))
          ];
          this.campaignsFiltered = this.campaignsList;
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    filterCampaigns(val, update) {
      update(this.defaultFilter(val, 'campaignsFiltered', this.campaignsList, 'name'));
    },

    clearFilter() {
      this.searchExecuted = false;
      this.lastSearchCampaignIds = [];
      (this.params = {
        orderId: null,
        actionId: null,
        bonusId: null,
        advertiserId: 0,
        campaignId: [],
        date: null,
        validation_date: null,
        status: null,
        commissionType: null,
        test_campaigns: false,
        segmentation: null,
        network_manager_id: 0,
        manager_id: 0,
        affiliateId: 0,
        payment_date: null
      }),
        // this.$refs.dateInput.clearValue();
        this.ActionSetFilterReports();
      this.getConversionReport();
    },

    async onFilterReports() {
      let filterSelect = [];

      if (this.params.orderId) filterSelect.push(`order_id=${this.params.orderId}`);
      if (this.params.actionId) filterSelect.push(`transaction_id=${this.params.actionId}`);
      if (this.params.bonusId) {
        filterSelect.push(`bonus_id=${this.params.bonusId}`);
        filterSelect.push(`comission_type=bonus`);
      }
      if (this.params.advertiserId) filterSelect.push(`advertiser_id=${this.params.advertiserId}`);
      if (this.params.segmentation) filterSelect.push(`segmentation=${this.params.segmentation}`);

      if (this.params.campaignId && this.params.campaignId.length > 0) {
        const realCampaigns = this.campaignsList.filter((c) => c.id !== 'select-all');
        const selectedCount = this.params.campaignId.length;

        if (selectedCount <= 10) {
          filterSelect.push(`campaign_id=${this.params.campaignId.join(',')}`);
        } else {
          const notSelectedIds = realCampaigns.filter((c) => !this.params.campaignId.includes(c.id)).map((c) => c.id);

          if (notSelectedIds.length > 0) {
            filterSelect.push(`not_in_campaign_id=${notSelectedIds.join(',')}`);
          }
        }
      }

      if (this.params.affiliateId) filterSelect.push(`affiliate_id=${this.params.affiliateId}`);
      if (this.params.siteId) filterSelect.push(`site_id=${this.params.siteId}`);
      if (this.params.manager_id) filterSelect.push(`manager_id=${this.params.manager_id}`);
      if (this.params.commissionType) filterSelect.push(`comission_type=${this.params.commissionType.value}`);
      if (this.params.network_manager_id) filterSelect.push(`network_manager_id=${this.params.network_manager_id}`);

      if (this.params.date) {
        let [from, , to] = this.params.date.split(' ');
        from = this.formatToEn(from);
        to = this.formatToEn(to);
        filterSelect.push(`start_date=${from}`);
        filterSelect.push(`end_date=${to}`);
      }

      if (this.params.validation_date) {
        let [from, , to] = this.params.validation_date.split(' ');
        from = this.formatToEn(from);
        to = this.formatToEn(to);
        filterSelect.push(`start_validation_date=${from}`);
        filterSelect.push(`end_validation_date=${to}`);
      }

      if (this.params.payment_date) {
        let [from, , to] = this.params.payment_date.split(' ');
        from = this.formatToEn(from);
        to = this.formatToEn(to);
        filterSelect.push(`start_payment_date=${from}`);
        filterSelect.push(`end_payment_date=${to}`);
      }

      if (this.params.status) filterSelect.push(`validation_status=${this.params.status.value}`);

      this.params.test_campaigns ? filterSelect.push(`test_campaigns=1`) : filterSelect.push(`test_campaigns=0`);

      this.lastSearchCampaignIds = [...this.params.campaignId];

      this.searchExecuted = true;

      this.ActionSetFilterReports(filterSelect.join('%26'));
      await this.getConversionReport();

      if (this.reports.length > 0) {
        this.addTotalValues();
      }
    },

    addTotalValues() {
      let totalIndex = localStorage.getItem('rowsPerPage') ? parseInt(localStorage.getItem('rowsPerPage')) : 11;
      totalIndex = totalIndex - 1;
      this.reports.splice(totalIndex, 0, {
        campaign_name: 'TOTAL:',
        transaction_amount: this.parseMoney(this.reportsTotal[0].transaction_amount),
        full_commission_amount: this.parseMoney(this.reportsTotal[0].full_commission_amount),
        affiliate_commission_cost: this.parseMoney(this.reportsTotal[0].affiliate_commission_cost),
        afilio_commition_margin: this.parseMoney(this.reportsTotal[0].afilio_commition_margin),
        created_at: this.$moment().format('YYYY-MM-DD')
      });

      this.$nextTick(() => {
        const rows = document.querySelectorAll('.q-table tbody tr');
        rows.forEach((row) => {
          const columns = row.querySelectorAll('td');
          columns.forEach((column) => {
            if (column.innerText.trim() === 'TOTAL:') {
              row.classList.add('total-row');
            }
          });
        });
      });
    }
  }
};
</script>
